// extracted by mini-css-extract-plugin
module.exports = {"row":"tableRow__row___rfGsu"};